import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DialogActions } from "@mui/material";
import { usePickerContext, usePickerTranslations } from "@mui/x-date-pickers/hooks";
export const PickerActionBar = (props)=>{
    const pickerContext = usePickerContext();
    const translations = usePickerTranslations();
    const buttons = {
        accept: {
            label: translations.okButtonLabel,
            onClick: pickerContext.acceptValueChanges
        },
        cancel: {
            label: translations.cancelButtonLabel,
            onClick: pickerContext.cancelValueChanges
        },
        next: {
            label: translations.nextStepButtonLabel,
            onClick: pickerContext.goToNextStep
        },
        today: {
            label: translations.todayButtonLabel,
            onClick: pickerContext.setValueToToday
        }
    };
    const actions = (props.actions ?? []).filter((action)=>action !== 'clear');
    return /*#__PURE__*/ _jsxs(DialogActions, {
        className: props.className,
        sx: {
            justifyContent: actions.length ? 'center' : undefined
        },
        children: [
            /*#__PURE__*/ _jsx(Button, {
                "data-testid": props['data-testid'],
                onClick: pickerContext.clearValue,
                variant: "text",
                children: translations.clearButtonLabel
            }),
            actions.map((action)=>{
                const resolved = action !== 'nextOrAccept' ? action : pickerContext.hasNextStep ? 'next' : 'accept';
                return /*#__PURE__*/ _jsx(Button, {
                    onClick: buttons[resolved].onClick,
                    variant: "text",
                    children: buttons[resolved].label
                }, action);
            })
        ]
    });
};
PickerActionBar.displayName = 'PickerActionBar';

//# sourceMappingURL=PickerActionBar.js.map